import React from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";

const MainTitle = ({ title }) => {
  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
};

MainTitle.propTypes = {
  title: PropTypes.string.isRequired,
};

export default MainTitle;
